<template>
  <div>
    <strong class="h2 resGrey--text text--darken-2">{{ title }} </strong>
    <span class="h3 resGrey--text text--darken-2">{{ budgetDescription }}</span>
    
    <new-edit-budget-dialog v-if="showNewEditBudgetDialog"
                            :showDialog="showNewEditBudgetDialog"
                            :maxWidth="1200"
                            :setWidth="1200"
                            :height="1900"
                            :budgetIterationId="budgetIterationId"
                            @save="saveBudgetSettings"
                            @cancel="closeNewEditBudgetDialog">
    </new-edit-budget-dialog>
  </div>
</template>

<script>
  import NewEditBudgetDialog from '../dialogs/NewEditBudgetDialog.vue';
  import budgetService from '@/services/budget';

  export default {
    name: 'BudgetPageHeader',
    components: {
      NewEditBudgetDialog
    },
    props: {
      budgetIterationId: {
        required: true
      },
      title: {
        required: true
      }
    },
    data () {
      return {
        budgetDescriptionData: {},
        showNewEditBudgetDialog: false
      };
    },
    methods: {
      async loadBudgetDescription() {
        this.budgetDescriptionData = await budgetService.getBudgetDescription(this.budgetIterationId);
      },
      async updateBudgetDescription(newBudgetDescription) {
        await budgetService.updateBudgetDescription(this.budgetIterationId, newBudgetDescription)
      },
      openNewEditBudgetDialog() {
        this.showNewEditBudgetDialog = true;
      },
      closeNewEditBudgetDialog() {
        this.showNewEditBudgetDialog = false;
      },
      async saveBudgetSettings() {
        await this.loadBudgetDescription();
        this.closeNewEditBudgetDialog();
      },
    },
    computed: {
      budgetDescription() {
        let description = '';
        if (this.budgetDescriptionData) {
          description += ` | ${this.budgetDescriptionData.year} ${this.budgetDescriptionData.propertyName} | ${this.budgetDescriptionData.accountingBasisName} |`;
          if (this.budgetDescriptionData.description) {
            description += ` ${this.budgetDescriptionData.description} |`;
          }
          if (this.budgetDescriptionData.budgetIterationTypeId == 2) {
            description += ` r${this.budgetDescriptionData.budgetIterationTypeSequence} |`;
          }
          description += ` v${this.budgetDescriptionData.versionNumber}`;
        }
        return description;
      }
    },
    // async created () {
    //   this.$eventHub.$on('budgetSettingsUpdated', this.loadBudgetDescription);
    // },
    async mounted () {
      await this.loadBudgetDescription();
    },
    watch: {
      async $route(to, from) {
        if(to.params.budgetIterationId != from.params.budgetIterationId) {
          await this.loadBudgetDescription()    
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  input.description-input {
    border: 1px solid black;
    border-radius:5px;
    margin: 0px;
    padding: 0px !important;
    background-color: var(--v-primary-lighten3);
    opacity:0.5;
    text-align:right;
  }
</style>
